import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  static values = {
    smsRouteId: String,
    metaAppId: String,
    metaConfigId: String,
    metaSolutionId: String
  }

  connect () {
    const embeddedSignupInfoListener = (event) => {
      if (!event.origin.endsWith('facebook.com')) return
      try {
        const data = JSON.parse(event.data)
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
            const { waba_id } = data.data
            fetchWithHandlingLoginRedirect(`/internal/api/sms-routes/${this.smsRouteIdValue}/whatsapp-sender`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                whatsAppBusinessAccountId: waba_id
              })
            }).then(() => {
              window.location.reload()
            })
          }
        }
      } catch {}
    }

    window.addEventListener('message', embeddedSignupInfoListener)
    window.addEventListener('beforeunload', () =>
      window.removeEventListener('message', embeddedSignupInfoListener)
    )

    window.fbAsyncInit = () => {
      FB.init({
        appId: this.metaAppIdValue,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v21.0'
      })
    }

    let script = document.createElement('script')
    script.id = 'facebook-jssdk'
    script.src = 'https://connect.facebook.net/en_US/sdk.js'
    document.body.appendChild(script)
  }

  onboard () {
    FB.login(
      function (response) {
      },
      {
        config_id: this.metaConfigIdValue,
        auth_type: 'rerequest',
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: 3,
          featureType: 'only_waba_sharing',
          setup: {
            solutionID: this.metaSolutionIdValue
          }
        }
      }
    )
  }
}
